/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { orderApprovalDetailsShippingInformationStyles } from "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsShippingInformation";
import getColor from "@insite/mobius/utilities/getColor";
import {
    addressTitleStyle,
    addressWrapper,
} from "@monsma/App/WidgetExtensions/Addresses/SharedAddressesComponentsStylesExtension";
import { addressInfoDisplayStyles } from "@monsma/Overrides/Components/AddressInfoDisplay";
import { css } from "styled-components";

export const sharedAddressTitleStyle = {
    variant: addressTitleStyle.variant,
    css: css`
        background: ${getColor("common.background")};
        border: 1px solid ${getColor("common.ui12")};
        width: 100%;
        border-bottom-width: 0;
        border-radius: 4px 4px 0 0;
        padding: 20px 20px 15px 20px;
        margin-bottom: 0;

        @media print {
            background: unset;
            border-width: 0;
            padding: 0;
        }
    `,
};

export const sharedContentStyle = {
    wrapper: {
        css: css`
            ${addressInfoDisplayStyles.wrapper?.css};
            ${addressWrapper?.css};
            min-height: auto;
            border-top-width: 0;
            padding: 0 20px 20px;
            border-radius: 0 0 4px 4px;
            width: 100%;
        `,
    },
};

orderApprovalDetailsShippingInformationStyles.shippingOtherInformationGridItem = {
    css: css`
        display: none !important;
    `,
};

orderApprovalDetailsShippingInformationStyles.shippingInformationTitleGridItem = {
    css: css`
        display: none !important;
    `,
};

orderApprovalDetailsShippingInformationStyles.shippingInformationGridContainer = {
    gap: 20,
    css: css`
        flex-direction: column;
        display: flex;
        height: 100%;
        > div {
            flex: 1;
        }
    `,
};

orderApprovalDetailsShippingInformationStyles.shippingInformationAddressGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
    `,
};

orderApprovalDetailsShippingInformationStyles.shippingAddressTitle = sharedAddressTitleStyle;

orderApprovalDetailsShippingInformationStyles.shippingAddress = sharedContentStyle;
